import moment from 'moment'

export function dateShortFormat (date: Date | string): string {
  if (date === undefined || date === null) {
    return '-'
  }
  try {
    return moment(date).format('YYYY.MM.DD')
  } catch (error) {
    return date.toString()
  }
}

export function dateLongFormat (date: Date | string): string {
  try {
    return moment(date).format('YYYY.MM.DD  HH:mm:ss')
  } catch (error) {
    return date.toString()
  }
}

export function dateWeekFormat (date: Date | string): string {
  try {
    const momentDate = moment(date)
    return `${momentDate.year()}.${('0' + momentDate.weeks()).slice(-2)}`
  } catch (error) {
    return ''
  }
}

export default { dateShortFormat, dateLongFormat, dateWeekFormat }
